import { render, staticRenderFns } from "./userDetailAddress.vue?vue&type=template&id=ec9f52aa&scoped=true"
import script from "./userDetailAddress.vue?vue&type=script&lang=js"
export * from "./userDetailAddress.vue?vue&type=script&lang=js"
import style0 from "./userDetailAddress.vue?vue&type=style&index=0&id=ec9f52aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9f52aa",
  null
  
)

export default component.exports